import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/filter/types'
import { IDoctorQueryProps } from '@/entities/Doctor'
import { IAppointmentQueryProps, IScheduleQueryProps } from '@/entities/Appointment'
import { IUserQueryProps } from '@/entities/User'
import { IAdmissionQueryProps } from '@/entities/Admission'
import { ICompanyQueryProps } from '@/entities/Company'

export default class FilterRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set doctor(value: IDoctorQueryProps | null) {
    this.store.commit(new types.Doctor(value ? { ...value } : null))
  }

  get doctor(): IDoctorQueryProps | null {
    return this.store.state.filter.doctor ? { ...this.store.state.filter.doctor } : null
  }

  set appointment(value: IAppointmentQueryProps | null) {
    this.store.commit(new types.Appointment(value ? { ...value } : null))
  }

  get appointment(): IAppointmentQueryProps | null {
    return this.store.state.filter.appointment
      ? { ...this.store.state.filter.appointment }
      : this.store.state.user.current?.properties?.filter?.appointment
      ? { ...this.store.state.user.current.properties.filter.appointment }
      : null
  }

  set user(value: IUserQueryProps | null) {
    this.store.commit(new types.User(value ? { ...value } : null))
  }

  get user(): IUserQueryProps | null {
    return this.store.state.filter.user ? { ...this.store.state.filter.user } : null
  }

  set admission(value: IAdmissionQueryProps | null) {
    this.store.commit(new types.Admission(value ? { ...value } : null))
  }

  get admission(): IAdmissionQueryProps | null {
    return this.store.state.filter.admission
      ? { ...this.store.state.filter.admission }
      : this.store.state.user.current?.properties?.filter?.admission
      ? { ...this.store.state.user.current.properties.filter.admission }
      : null
  }

  set schedule(value: IScheduleQueryProps | null) {
    this.store.commit(new types.Schedule(value ? { ...value } : null))
  }

  get schedule(): IScheduleQueryProps | null {
    return this.store.state.filter.schedule
      ? { ...this.store.state.filter.schedule }
      : this.store.state.user.current?.properties?.filter?.schedule
      ? { ...this.store.state.user.current.properties.filter.schedule }
      : null
  }

  set company(value: ICompanyQueryProps | null) {
    this.store.commit(new types.Company(value ? { ...value } : null))
  }

  get company(): ICompanyQueryProps | null {
    return this.store.state.filter.company ? { ...this.store.state.filter.company } : null
  }
}
